import type { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';

export async function fetchAdoResource<T>(
  discoveryApi: DiscoveryApi,
  fetchApi: FetchApi,
  path: string,
): Promise<T> {
  const baseUrl = await discoveryApi.getBaseUrl('tjp-ado-resources');

  const response = await fetchApi.fetch(`${baseUrl}${path}`);

  if (!response.ok) {
    const body = (await response.json()) as {
      error?: string;
    };

    throw new Error(
      body.error ?? `Azure DevOps request failed (${response.status})`,
    );
  }

  return (await response.json()) as T;
}
